module.exports = __webpack_public_path__ + "static/img/5.de0a51b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/5.png
// module id = NKNf
// module chunks = 0